<template>
  <div class="fixed top-0 left-0 w-screen h-screen-safe">
    <iframe v-if="artwork" class="w-full h-full" :src="artwork.artwork_url" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { generateMetaTags } from '@/util'

export default {
  name: 'Artwork',

  metaInfo () {
    return {
      title: this.pageTitle,
      meta: generateMetaTags(this.pageTitle, this.pageDescription, this.pageImage)
    }
  },

  computed: {
    ...mapState(['artworks']),

    pageTitle () {
      return this.artwork ? this.artwork.title : null
    },

    pageDescription () {
      return this.artwork ? this.artwork.description : null
    },

    pageImage () {
      return this.artwork && this.artwork.cover_image ? this.artwork.cover_image.src : null
    },

    slug () {
      return this.$route.params.slug
    },
  },

  data () {
    return {
      artwork: false
    }
  },

  async mounted () {
    await this.$store.dispatch('getArtwork', this.slug)
    this.artwork = this.artworks[this.slug]

    if (!this.artwork.artwork_url) {
      // if no artwork url, redirect back to artwork page
      this.$router.push(`/artworks/${this.slug}`)
    }
  }
}
</script>